import { render, staticRenderFns } from "./contractUserShop.vue?vue&type=template&id=b8355ec2&scoped=true&"
import script from "./contractUserShop.vue?vue&type=script&lang=js&"
export * from "./contractUserShop.vue?vue&type=script&lang=js&"
import style0 from "./contractUserShop.vue?vue&type=style&index=0&id=b8355ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8355ec2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8355ec2')) {
      api.createRecord('b8355ec2', component.options)
    } else {
      api.reload('b8355ec2', component.options)
    }
    module.hot.accept("./contractUserShop.vue?vue&type=template&id=b8355ec2&scoped=true&", function () {
      api.rerender('b8355ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/modifySupplement/contractUserShop.vue"
export default component.exports